"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import Maps from "@/components/partials/Maps";

export default function Consultoria({ data }) {
  const banner = data?.contentAttachments1?.map(item => {
    const hasImage = item?.attachFiles?.mediaCdnUrl || null;
    if(hasImage) {
      return {
        src: hasImage,
        title: item?.attachField1 || '',
        description: item?.attachField2 || ''
      }
    }

    return false;
  }).filter(f => f !== false)[0] || [];

  const consultorias = data?.contentAttachments2?.map(item => {
    return {
      title: item?.attachField1 || '',
      description: item?.attachField2 || '',
      url: item?.attachField3 || ''
    }
  }).filter(f => f !== false) || [];

  return (
    <div className="w-full min-h-screen bg-gray-50">
      {/* Banner com imagem */}
      <section className="relative w-full h-[400px] md:h-[800px] overflow-hidden">
        <Image
          src={ banner.src }
          alt="Consultoria Contábil"
          fill
          priority
          className="object-cover object-center"
        />

        { banner.title && banner.description && (
          <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center px-4">
            <div className="text-center text-white max-w-[900px]">
              { banner.title  && (
                <h1 className="text-[32px] sm:text-[40px] md:text-[50px] font-bold mb-4">
                  { banner.title }
                </h1>
              )}

              { banner.description && (
                <div className="text-[16px] sm:text-[18px] md:text-[20px] leading-snug">
                  { banner.description }
                </div>
              )}
            </div>
          </div>
        )}
      </section>

      {/* Seção de opções */}
      <section className="w-full py-16 px-4 bg-white">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Pequenas e Médias Empresas */}
          { consultorias.map((item, index) => (
            <Link
              key={index}
              href={item.url}
              className="group bg-gray-100 hover:bg-blue-50 transition-all duration-300 p-8 rounded-2xl shadow-md border border-gray-200 hover:border-blue-400"
            >
              <h2 className="text-[24px] sm:text-[28px] font-bold text-blue-900 mb-4 group-hover:text-blue-700">
                { item.title }
              </h2>
              <div className="text-gray-700 text-[16px] leading-relaxed">
                { item.description }
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
